import { Controller } from "@hotwired/stimulus";
import { showTab } from "../ui/bootstrap_ui";

// Put on the `ul.nav-tabs` of a page with tabs. The tab named by the URL hash
// is opened (the default one without or with an unknown hash) and following
// another tab puts its id into the hash, so a link to the page can open it.
export default class extends Controller {
  static values = {default: String};

  connect() {
    this.selecting = true;
    const link = this.linkFor(window.location.hash.slice(1)) || this.linkFor(this.defaultValue);
    if (link) showTab(link);
    this.selecting = false;
  }

  linkFor(id) {
    if (!id) return null;
    return Array.from(this.element.querySelectorAll('a[data-toggle="tab"]')).find(
      (link) => link.getAttribute("href") === `#${id}`
    );
  }

  shown(event) {
    if (this.selecting) return;
    // No history entry and no jump to the anchor, the page goes to the top.
    // Keep the state: Turbo keeps its restoration data of the entry in it.
    window.history.replaceState(window.history.state, "", event.target.hash);
    window.scrollTo(0, 0);
  }
}
